/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArticlePastSearchListItemV2
 */
export interface ArticlePastSearchListItemV2 {
    /**
     * 過去記事のID
     * @type {number}
     * @memberof ArticlePastSearchListItemV2
     */
    id: number;
    /**
     * 過去記事のタイトル
     * @type {string}
     * @memberof ArticlePastSearchListItemV2
     */
    title: string;
    /**
     * 過去記事のタイトル
     * @type {string}
     * @memberof ArticlePastSearchListItemV2
     */
    url: string;
    /**
     * 収集元のサイト名
     * @type {string}
     * @memberof ArticlePastSearchListItemV2
     */
    siteName: string;
    /**
     * 収集元の媒体社名
     * @type {string}
     * @memberof ArticlePastSearchListItemV2
     */
    siteCompanyName: string;
    /**
     * 過去記事のジャンル
     * @type {string}
     * @memberof ArticlePastSearchListItemV2
     */
    genreName: string;
    /**
     * 過去記事の掲載種別
     * @type {string}
     * @memberof ArticlePastSearchListItemV2
     */
    pubName: string;
    /**
     * 広告換算額
     * @type {number}
     * @memberof ArticlePastSearchListItemV2
     */
    advertisingConversionValue: number;
    /**
     * マッチしたキーワード
     * @type {Array<string>}
     * @memberof ArticlePastSearchListItemV2
     */
    matchKey: Array<string>;
    /**
     * 過去記事の取得日(yyyy/mm/dd)
     * @type {string}
     * @memberof ArticlePastSearchListItemV2
     */
    acquiredAt: string;
}

export function ArticlePastSearchListItemV2FromJSON(json: any): ArticlePastSearchListItemV2 {
    return ArticlePastSearchListItemV2FromJSONTyped(json, false);
}

export function ArticlePastSearchListItemV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchListItemV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'url': json['url'],
        'siteName': json['site_name'],
        'siteCompanyName': json['site_company_name'],
        'genreName': json['genre_name'],
        'pubName': json['pub_name'],
        'advertisingConversionValue': json['advertising_conversion_value'],
        'matchKey': json['match_key'],
        'acquiredAt': json['acquired_at'],
    };
}

export function ArticlePastSearchListItemV2ToJSON(value?: ArticlePastSearchListItemV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'url': value.url,
        'site_name': value.siteName,
        'site_company_name': value.siteCompanyName,
        'genre_name': value.genreName,
        'pub_name': value.pubName,
        'advertising_conversion_value': value.advertisingConversionValue,
        'match_key': value.matchKey,
        'acquired_at': value.acquiredAt,
    };
}

